// File: frontend/src/components/Layout/AuthLayout.jsx
// Layout for authentication pages (login, register, etc.)

import React from 'react';
import WALogo from '../UI/WALogo';

const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="flex justify-center">
          <WALogo size="xl" showText={true} className="mb-4" />
        </div>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          CRM Contact Center
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          {children}
        </div>
      </div>

      <div className="mt-8 text-center">
        <p className="text-sm text-gray-600">
          © 2024 Contact Center. Todos os direitos reservados.
        </p>
      </div>
    </div>
  );
};

export default AuthLayout;